export const AnchorStyle = {
  anchor: {
    position: 'absolute',
    top: '-100px',
  },
} as const;
